
// ensure jQuery is loaded
if (!window.jQuery && typeof(themedir) !== 'undefined'){
    document.write('<script src="' + themedir + '/bower_components/jquery/dist/jquery.min.js"></script>');  // eslint-disable-line no-undef
}

// Avoid `console` errors in browsers that lack a console.
(function() {
    /* eslint-disable no-console */
    var method;
    var noop = function () {};
    var methods = [
        'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
        'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
        'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
        'timeStamp', 'trace', 'warn'
    ];
    var length = methods.length;
    var console = (window.console = window.console || {});

    while (length--) {
        method = methods[length];

        // Only stub undefined methods.
        if (!console[method]) {
            console[method] = noop;
        }
    }
    /* eslint-enable no-console */
}());
